import {createSlice} from "@reduxjs/toolkit";

import {listCharts, fetchChart} from "../../api/chartsApi";

const chartsSlice = createSlice({
  name: 'charts',
  initialState: {
    page: 0,
    charts: [],
    loading: false,
    error: null,
    chartLoading: {},  // Track loading state per chart
    chartErrors: {}    // Track errors per chart
  },
  reducers: {
    clearChartError: (state, action) => {
      const chartTitle = action.payload;
      delete state.chartErrors[chartTitle];
    }
  },
  extraReducers: (builder) => {
    builder
      // List Charts
      .addCase(listCharts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listCharts.fulfilled, (state, action) => {
        state.loading = false;
        state.page = action.payload.page;
        // Merge new charts with existing ones, preventing duplicates
        const newCharts = action.payload.data;
        const existingTitles = new Set(state.charts.map(chart => chart.title));
        state.charts = [
          ...state.charts,
          ...newCharts.filter(chart => !existingTitles.has(chart.title))
        ];
      })
      .addCase(listCharts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Single Chart
      .addCase(fetchChart.pending, (state, action) => {
        const chartTitle = action.meta.arg;
        state.chartLoading[chartTitle] = true;
        delete state.chartErrors[chartTitle];
      })
      .addCase(fetchChart.fulfilled, (state, action) => {
        const chartTitle = action.meta.arg;
        state.chartLoading[chartTitle] = false;

        // If action.payload is null, it means we already had the data
        if (action.payload) {
          // Update the existing chart with the new data
          state.charts = state.charts.map(chart =>
            chart.title === chartTitle
              ? { ...chart, plot_data: action.payload.plot_config }
              : chart
          );
        }
      })
      .addCase(fetchChart.rejected, (state, action) => {
        const chartTitle = action.meta.arg;
        state.chartLoading[chartTitle] = false;
        state.chartErrors[chartTitle] = action.payload;
      });
  }
});

export const { clearChartError } = chartsSlice.actions;

// Selectors
export const selectCharts = (state) => state.charts.charts;
export const selectChartsLoading = (state) => state.charts.loading;
export const selectChartsError = (state) => state.charts.error;
export const selectCurrentPage = (state) => state.charts.page;
export const selectChartLoadingState = (title) => (state) => state.charts.chartLoading[title];
export const selectChartError = (title) => (state) => state.charts.chartErrors[title];

export default chartsSlice.reducer;